import { render, staticRenderFns } from "./AlbumAvatarZone.vue?vue&type=template&id=29bbd7e8&scoped=true&"
import script from "./AlbumAvatarZone.vue?vue&type=script&lang=js&"
export * from "./AlbumAvatarZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumAvatarZone.vue?vue&type=style&index=0&id=29bbd7e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bbd7e8",
  null
  
)

export default component.exports